import { Navigate } from 'react-router';

import { ANY_SPORT_PLAYERS_SLUG_CARDS_SALES_HISTORY } from '@sorare/core/src/constants/__generated__/routes';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

import { useLayoutData } from '#src/pages/players/$slug/layout.tsx';

const TransactionsPage = () => {
  const { player } = useLayoutData();

  return (
    <Navigate
      to={generateSportPath(ANY_SPORT_PLAYERS_SLUG_CARDS_SALES_HISTORY, {
        params: {
          slug: player.slug,
        },
        sport: player.sport,
      })}
    />
  );
};

export default TransactionsPage;
